import { types } from 'mobx-state-tree';
import Picture from './Picture.js';
import { Variations } from './Variations';
import { PricingStrategy } from './PricingStrategy';

export const Item = types
  .model('Item', {
    id: types.string,
    accountId: types.string,
    title: types.string,
    listDate: types.string,
    lastUpdatedDate: types.maybe(types.string),
    sourceMarketplaceId: types.string,
    sourceMarketplaceName: types.string,
    sourceItemCode: types.maybe(types.string),
    destinationItemId: types.maybe(types.string),
    destinationItemUrl: types.maybe(types.string),
    pricingStrategy: types.maybe(PricingStrategy),
    status: types.optional(types.string, ''),
    quantity: types.number,
    quantitySold: types.number,
    templateId: types.string,
    monitoringStatus: types.optional(types.string, ''),
    pictures: types.optional(types.array(Picture), []),
    // labels: types.optional(types.array(Label), []),
    // specifics: types.optional(types.array(Specific), []),
    timeLeftDays: types.optional(types.number, 0),
    withoutSalesDays: types.optional(types.number, 0),
    sellerAccountName: types.optional(types.string, ''),
    variations: types.optional(types.array(Variations), []),
    isMarketplace: types.optional(types.boolean,false),
  })
  .views(self => ({
    get variationsReady() {
      if (self.variations.some(vari => !vari.ready)) {
        return false;
      }
      return true;
    },
  }));
